import { Button } from '@/components/button';
import { Col, Form, Row, Select, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import {
  getListAdminUser,
} from '@/redux/slices/admin.slice';
import { PAGINATION_PARAMS } from '@/constants/pagination.constant';
import { useAppDispatch } from '@/redux/hooks';
import { fetchModules } from '@/redux/slices/module.slice';

type AdminActivityLogSearcherProps = {
  onSearch: (values: FilterAdminActivityLog) => void;
};

// const { RangePicker } = DatePicker;

export const ChatGPTSearcher = ({
  onSearch
}: AdminActivityLogSearcherProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();

  const statusData = [
    {
      name: 'Tất cả',
      value: 3
    },
    {
      name: 'Hiển thị',
      value: 1
    },
    {
      name: 'Ẩn',
      value: 2
    }
  ];

  const statusOptions = [
    ...statusData.map((status) => ({
      value: status.value,
      label: status.name
    }))
  ];
 
  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  const handleReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    dispatch(getListAdminUser({ offset: 1, limit: PAGINATION_PARAMS.unLimit }));
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchModules());
  }, [dispatch]);

  return (
    <Form
      form={form}
      name="user-client-searcher"
      layout="horizontal"
      labelCol={{ span: 4 }}
      wrapperCol={{ span: 20 }}
    >
      <Row gutter={[20, 0]} align="middle" justify="center">
        <Col span={8}>
          <Row gutter={[10, 0]} align="middle">
            <Col span={6}>
              <label>Ngày cập nhật</label>
            </Col>
            <Col span={8}>
              <Form.Item name="startDate" noStyle>
                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={2} style={{ textAlign: "center" }}>-</Col>
            <Col span={8}>
              <Form.Item name="endDate" noStyle>
                <DatePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={6}>
          <Row gutter={[10, 0]} align="middle" justify="center">
            <Col span={6}>
              <label>Trạng thái</label> 
            </Col>
            <Col span={8}>
              <Form.Item name="active" initialValue={3} noStyle>
                <Select
                  showSearch
                  allowClear
                  placeholder="Tất cả"
                  optionFilterProp="label"
                  options={statusOptions}
                  style={{ width: "100%" }} 
                />
              </Form.Item>
            </Col>
          </Row>
        </Col>

        <Col span={8}>
          <Row gutter={[16, 0]}>
            <Col>
              <Button onClick={handleReset} type="default">
                Xoá bộ lọc
              </Button>
            </Col>
            <Col>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                onClick={handleSearch}
              >
                Tìm kiếm
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>

  );
};